import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";

interface IProps {
    buttonText: string;
    isDisabled?: boolean;
    isPlaceholder?: boolean;
    isLoading?: boolean;
    showStep?: boolean;
    onClick?: () => void;
    className?: string;
    buttonClassName?: string;
    dataTestId?: string;
}

export const ForYouModalButton = (props: IProps) => {
    const {buttonText, isLoading, isDisabled, onClick, buttonClassName, className, showStep, dataTestId} = props;

    const modalStep = useAppSelector((state) => state.forYouModal.step);
    const {isMobile} = useUserDevice();

    const displayStep = showStep && [ForYouModalStep.REGION, ForYouModalStep.CRITERIA, ForYouModalStep.USER].includes(modalStep) && isMobile;

    return (
        <div className={cx(sticky, className)}>
            <Button
                variant="filled_primary"
                size="small"
                type="submit"
                className={cx(buttonClassName, buttonStyle)}
                disabled={isDisabled}
                onClick={onClick}
                dataTestId={dataTestId}
            >
                {isLoading && <Loader size="sm" />}
                {!isLoading && buttonText}
            </Button>
            {displayStep && (
                <Text variant="info_txt_2" align="center">
                    Krok {modalStep}/3
                </Text>
            )}
        </div>
    );
};

const buttonStyle = css({
    width: "100%",
    mb: 1
});

const sticky = css({
    position: "sticky",
    bottom: 0,
    zIndex: 1001,
    ml: -1.5,
    mr: -1.5,
    pt: 2,
    pr: 2,
    pb: 1,
    pl: 2,
    backgroundColor: "#fff",
    md: {
        backgroundColor: "inherit"
    }
});
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {useAppSelector} from "../../../store/hooks";
import {ForYouModalStep} from "../../types/ForYouModalStep";

interface IProps {
    buttonText: string;
    isDisabled?: boolean;
    isPlaceholder?: boolean;
    isLoading?: boolean;
    showStep?: boolean;
    onClick?: () => void;
    className?: string;
    buttonClassName?: string;
    dataTestId?: string;
}

export const ForYouModalButton = (props: IProps) => {
    const {buttonText, isLoading, isDisabled, onClick, buttonClassName, className, showStep, dataTestId} = props;

    const modalStep = useAppSelector((state) => state.forYouModal.step);
    const {isMobile} = useUserDevice();

    const displayStep = showStep && [ForYouModalStep.REGION, ForYouModalStep.CRITERIA, ForYouModalStep.USER].includes(modalStep) && isMobile;

    return (
        <div className={cx(sticky, className)}>
            <Button
                variant="filled_primary"
                size="small"
                type="submit"
                className={cx(buttonClassName, buttonStyle)}
                disabled={isDisabled}
                onClick={onClick}
                dataTestId={dataTestId}
            >
                {isLoading && <Loader size="sm" />}
                {!isLoading && buttonText}
            </Button>
            {displayStep && (
                <Text variant="info_txt_2" align="center">
                    Krok {modalStep}/3
                </Text>
            )}
        </div>
    );
};

const buttonStyle = css({
    width: "100%",
    mb: 1
});

const sticky = css({
    position: "sticky",
    bottom: 0,
    zIndex: 1001,
    ml: -1.5,
    mr: -1.5,
    pt: 2,
    pr: 2,
    pb: 1,
    pl: 2,
    backgroundColor: "#fff",
    md: {
        backgroundColor: "inherit"
    }
});
